import TagManager from 'react-gtm-module'

export function gtmSetup() {
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID || ''
  return TagManager.initialize({ gtmId })
}
